/*
 * Keeps the Free Gifts (BOGOS) popup ABOVE the modal cart drawer.
 *
 * The cart drawer is a modal <dialog>, which the browser paints in the "top
 * layer" — above ALL normal content no matter the z-index — so the gift popup
 * was hidden behind it. We relocate the popup INTO the open dialog (same top
 * layer, higher z-index) while the drawer is open, then move it back home when
 * it closes so the app keeps managing it normally.
 *
 * This lives in its own file (loaded via snippets/lb-assets.liquid) because the
 * larger bundles are edge-cached and slow to update; guarded so it runs once.
 */
(function () {
  if (window.__lbGiftFix) return;
  window.__lbGiftFix = true;

  var SEL = '.freegifts-main-container.sca-modal-fg';
  var VISIBLE = 'sca-is-visible-fg';

  function modalDialog() {
    var dialogs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogs.length; i++) {
      try {
        if (dialogs[i].matches(':modal')) return dialogs[i];
      } catch (e) {}
    }
    return null;
  }

  var moved = null;
  var home = null;

  function place() {
    var gift = document.querySelector(SEL);
    var visible = gift && gift.classList.contains(VISIBLE);
    var dialog = modalDialog();

    if (gift && visible && dialog) {
      if (gift.parentElement !== dialog) {
        if (!home) home = gift.parentElement;
        dialog.appendChild(gift);
        gift.classList.add('lb-gift-over-drawer');
        moved = gift;
      }
    } else if (moved) {
      if (home && moved.parentElement !== home) home.appendChild(moved);
      moved.classList.remove('lb-gift-over-drawer');
      moved = null;
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });
    place();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
